import React, { Component } from 'react';
import './Panel.css';
import Button from '../Button/Button';

class Panel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            pc: 0,
            tarPc: 0,
            hideInner: true,
            intervalId: -1
        };

        this.scrollHeight = 0;

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentDidUpdate() {

    };

    static propTypes =  {
        headline:      React.PropTypes.string,
        text:       React.PropTypes.string,
        text_short:      React.PropTypes.string,
        buttons:      React.PropTypes.array,
        onChange:   React.PropTypes.func,
        cols: React.PropTypes.number
    }

    static defaultProps () {
        return {
            value: ''
        };
    }

    handleClick = (e) =>  {
        //console.log(("handleClick " + this.state.expanded);
        var intervalId;

        if (
            !this.state.expanded
        ) {
            this.setState({expanded: true});
            clearInterval(this.state.intervalId);
            this.setState({tarPc: 1});

            intervalId = setInterval(this.timer, 50);
            this.setState({intervalId: intervalId});
            this.setState({hideInner: false});

            ////console.log(("window.innerHeight    - handleClick: " + window.innerHeight);
            ////console.log(("headline.scrollHeight - handleClick: " + this.headline.scrollHeight);

            if (window.innerHeight < 500) {
                this.scrollHeight = window.innerHeight - this.headline.scrollHeight - 100;
            } else {
                this.scrollHeight = window.innerHeight - this.headline.scrollHeight - 280;
            }


            //this.scrollHeight = 50;

            ////console.log(("scrollHeight - handleClick:          " + this.scrollHeight);

        } else if (
            this.state.expanded
        ) {
            this.setState({expanded: false});
            this.setState({tarPc: 0});

            clearInterval(this.state.intervalId);
            intervalId = setInterval(this.timer, 50);
            this.setState({intervalId: intervalId});

        }

        this.setState({expanded: !this.state.expanded});
        if (typeof this.props.onChange === 'function') {
            this.props.onChange();
        }

    }

    timer = (e) =>  {
        var pc = this.state.pc;
        pc += (this.state.tarPc - pc)/3;
        this.setState({pc: pc});

        ////console.log(("pc - timer: " + pc);

        if (Math.abs(this.state.tarPc - this.state.pc) < 0.05) {
            clearInterval(this.state.intervalId);

            if (this.state.tarPc === 0) {
                this.setState({hideInner: true});
            }

            if (this.state.tarPc === 1) {
                //console.log(("scrollCon - timer: " + this.scrollCon.scrollHeight);
                if (this.scrollCon !== undefined && !isNaN(this.scrollCon.scrollHeight)) {
                    //this.scrollHeight = this.scrollCon.scrollHeight;
                    if (this.headline !== undefined) {
                        //this.scrollHeight -= this.headline.scrollHeight*3;
                    }
                }
            }

            this.setState({pc: this.state.tarPc});

        }

    }


  render() {

        var text = "";
        var interactive = false;
        if (this.props.text !== undefined && this.props.text_short !== undefined && this.props.text.length > 0 && this.props.text_short.length > 0) {
            if (this.state.expanded) {
                text = this.props.text_short + this.props.text;
            } else {
                text = this.props.text_short;
            }
            interactive = true;
        } else if (this.props.text !== undefined && this.props.text.length > 0) {
            text = this.props.text;
        } else if (this.props.text_short !== undefined && this.props.text_short.length > 0) {
            text = this.props.text_short;
        }

        var cl = interactive ? "Panel-Interactive" : "Panel-Default";

        var clickFunc = interactive ? this.handleClick : null;

        if (this.props.headline === undefined || this.props.headline === "") {
            return (<div></div>);
        }


        var buttons = [];

        if (this.props.buttons !== undefined && this.props.buttons.length > 0) {
            var k = 0;
            buttons = this.props.buttons.map((btn) =>
                <Button key={(k++).toString()} cssClass="Button-Panel" className={btn.to} values={btn} onChange={null} />
            );
        }

      //var mh = (this.scrollHeight * this.state.pc);
      var mh = (this.scrollHeight* this.state.pc);


      //console.log(("mh - timer: " + mh + " pc " + this.state.pc);

      var txt_comp = this.props.text_short + this.props.text;


        if (this.props.cols === 2) {
            return (
                <div className="Panel">
                    <div className={"PanelContent row " + cl}>
                            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                                <div className="InnerContainer" >

                                    <h3 ref={(r) => { this.headline = r; }} onClick={clickFunc}>{this.props.headline}</h3>

                                    {!this.state.expanded &&
                                    <div className="TextShort hidden-sm hidden-xs"
                                         dangerouslySetInnerHTML={{__html: this.props.text_short}}></div>
                                    }

                                    <div ref={(d) => { this.scrollCon = d; }} className="ScrollContainer" style={{'maxHeight': mh + 'px'}}>

                                        <div className="TextShort"
                                             dangerouslySetInnerHTML={{__html: txt_comp}}></div>
                                    </div>

                                    {!this.state.expanded &&
                                        <p className="BtnMoreLess"><span className="link" onClick={clickFunc}>
                                            <i className="material-icons">keyboard_arrow_right</i>
                                            <span className="hidden-sm hidden-xs">Weiterlesen</span></span>
                                        </p>

                                    }

                                    {this.state.expanded &&
                                    <p className="BtnMoreLess">
                                        <span className="link" onClick={clickFunc}>
                                            <i className="material-icons hidden-sm hidden-xs">keyboard_arrow_down</i>
                                            <i className="material-icons hidden-lg hidden-md">keyboard_arrow_down</i>
                                            <span className="hidden-sm hidden-xs">Weniger</span>
                                        </span>
                                    </p>
                                    }


                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                {buttons.length > 0 && (!this.state.expanded) &&
                                <div className="ButtonContainer hidden-md hidden-lg">
                                    {buttons}
                                </div>
                                }
                                {buttons.length > 0 &&
                                <div className="ButtonContainer hidden-sm hidden-xs">
                                    {buttons}
                                </div>
                                }

                            </div>
                    </div>
                </div>

            );
        } else {
            return (
                <div className="Panel">
                    <div className={"PanelContent " + cl}>
                        <div className="InnerContainer" >
                            <h3>{this.props.headline}</h3>

                            <div className="InnerHtml" dangerouslySetInnerHTML={{__html: text}}></div>

                            {interactive && !this.state.expanded &&
                            <p className="BtnMoreLess"><span className="link" onClick={clickFunc}><i className="material-icons">keyboard_arrow_down</i>Weiterlesen</span></p>
                            }
                            {interactive && this.state.expanded &&
                            <p className="BtnMoreLess"><span className="link" onClick={clickFunc}><i className="material-icons">keyboard_arrow_up</i>Weniger</span></p>
                            }
                            {buttons.length > 0 &&
                            <div className="ButtonContainer">
                                {buttons}
                            </div>
                            }
                        </div>
                    </div>
                </div>

            );
        }


  }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/Panel/Panel.js